/* eslint-disable
    @typescript-eslint/no-explicit-any
*/
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

interface CrumbLinkProps {
  className: string;
  isLoading?: boolean;
  onClick?: (...args: Array<any>) => any;
  // When provided, truncates the crumb with ellipsis at this width in pixels.
  // Should be paired with keepCrumbsInline=true on parent Breadcrumbs.
  maxCrumbWidth?: number;
}

export class CrumbLink extends React.Component<CrumbLinkProps> {
  static defaultProps = {
    className: 'genericBreadcrumbs-link',
  };

  styles = StyleSheet.create({
    truncatedCrumb: {
      maxWidth: this.props.maxCrumbWidth,
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  });

  render(): JSX.Element {
    if (this.props.isLoading) {
      return <span className={this.props.className}>...</span>;
    } else {
      return (
        <a
          className={classNames(
            this.props.className,
            this.props.maxCrumbWidth != null && css(this.styles.truncatedCrumb)
          )}
          onClick={this.props.onClick}
          role="link"
          tabIndex={0}
        >
          {this.props.children}
        </a>
      );
    }
  }
}

interface BreadcrumbsProps {
  className: string;
  // When true, will use a flex layout to keep the crumbs on one line. Can be paired with maxCrumbWidth on children CrumbLinks to support truncation.
  // When false, will use a block layout to wrap the crumbs if needed and stack long crumbs on multiple lines.
  keepCrumbsInline?: boolean;
}

// TODO(T7355): Generalize component to support existing Breadcrumbs (i.e. nav) and change classNames to
// '.breadcrumbs'.
class Breadcrumbs extends React.Component<BreadcrumbsProps> {
  static defaultProps = {
    className: 'genericBreadcrumbs',
    keepCrumbsInline: false,
  };

  _renderCrumbs = (crumbs: Array<React.ReactNode>): React.ReactNode => {
    if (crumbs.length === 0) {
      return [];
    } else if (crumbs.length === 1) {
      return crumbs.concat(' / ');
    } else {
      // crumbs.length >= 2
      return [
        crumbs[0],
        ' / ',
        <span
          key="sub-crumbs"
          className={this.props.keepCrumbsInline ? css(styles.truncatedSubCrumb) : undefined}
        >
          {this._renderCrumbs(crumbs.slice(1))}
        </span>,
      ];
    }
  };

  render(): JSX.Element {
    const children = React.Children.toArray(this.props.children);
    return (
      <div
        className={classNames(
          this.props.className,
          'legacy-font-proxima-13',
          this.props.keepCrumbsInline && css(styles.breadcrumbsWithTruncation)
        )}
      >
        {this._renderCrumbs(children)}
      </div>
    );
  }
}

export default Breadcrumbs;

const styles = StyleSheet.create({
  breadcrumbsWithTruncation: {display: 'flex'},
  truncatedSubCrumb: {
    display: 'flex',
  },
});
